module.exports = __webpack_public_path__ + "img/jobpost.cfa011a4.svg";